import { render, staticRenderFns } from "./ShowFeedbackModal.vue?vue&type=template&id=0fc2dff3"
import script from "./ShowFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ShowFeedbackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports